// ==============================
// KycRouter.js
// Componente che gestisce il resume del flusso KYC
// Reindirizza l'utente al prossimo step da completare
// ==============================

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../api';
import { COLORS, SEMANTIC, UI } from '../styles/theme';

const KycRouter = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const checkKycStatus = useCallback(async () => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      navigate('/login');
      return;
    }

    try {
      const response = await API.get(`/kyc/status?user_id=${userId}`);
      const data = response.data;

      if (data.kyc_completed) {
        // KYC completato: vai alla selezione portafoglio
        navigate('/select-portfolio-type');
      } else {
        // KYC incompleto: redirect al prossimo step
        navigate(data.next_route);
      }
    } catch (err) {
      console.error('Errore nel recupero stato KYC:', err);
      setError('Errore nel caricamento dello stato KYC');
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    checkKycStatus();
  }, [checkKycStatus]);

  // ==============================
  // Schermata di caricamento durante il check
  // ==============================
  if (loading && !error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: SEMANTIC.backgroundApp,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ color: SEMANTIC.ctaPrimary, width: '3rem', height: '3rem' }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p
          style={{
            color: SEMANTIC.textPrimary,
            marginTop: UI.spacing.xl,
            fontSize: UI.fontSize.lg,
          }}
        >
          {t('kyc.router_loading')}
        </p>
      </div>
    );
  }

  // ==============================
  // Schermata di errore
  // ==============================
  if (error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: SEMANTIC.backgroundApp,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: UI.spacing.xl,
        }}
      >
        <i
          className="bi bi-exclamation-triangle"
          style={{
            fontSize: '48px',
            color: COLORS.BRAND_RED.hex,
            marginBottom: UI.spacing.lg,
          }}
        />
        <p
          style={{
            color: SEMANTIC.textPrimary,
            fontSize: UI.fontSize.lg,
            textAlign: 'center',
          }}
        >
          {error}
        </p>
        <button
          onClick={() => {
            setError(null);
            setLoading(true);
            checkKycStatus();
          }}
          style={{
            marginTop: UI.spacing.xl,
            padding: `${UI.spacing.md} ${UI.spacing.xl}`,
            background: SEMANTIC.ctaPrimary,
            color: SEMANTIC.ctaPrimaryText,
            border: 'none',
            borderRadius: UI.borderRadius.md,
            fontSize: UI.fontSize.lg,
            fontWeight: UI.fontWeight.bold,
            cursor: 'pointer',
          }}
        >
          Riprova
        </button>
      </div>
    );
  }

  return null;
};

export default KycRouter;
